package com.swetdot.swetgram.ui.picso

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.swetdot.swetgram.domain.PicsoPostItem
import kotlin.time.Instant

@Composable
fun PicsoCard(post: PicsoPostItem, onClick: () -> Unit, loadImage: suspend (String) -> ByteArray, now: () -> Instant) {
    Box(Modifier.aspectRatio(1f).clip(RoundedCornerShape(16.dp)).background(Color(0xFF202020)).clickable(onClick = onClick)) {
        PicsoImage(post, loadImage, now, Modifier.fillMaxSize())
        Text(
            text = "@${post.authorUsername}",
            color = Color.White,
            fontWeight = FontWeight.Bold,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.align(Alignment.TopStart).fillMaxWidth()
                .background(Color.Black.copy(alpha = 0.55f)).padding(10.dp),
        )
    }
}
